
import { useEffect, useRef } from "react";

const PeopleFeedAds = () => {
    const adRef = useRef(null);

    useEffect(() => {
        // Check if the ad script is loaded and if the current ad instance is not already initialized
        if (adRef.current && window.adsbygoogle && !adRef.current.isInitialized) {
            try {
                window.adsbygoogle.push({});
                adRef.current.isInitialized = true; // Mark this ad as initialized
            } catch (error) {
                console.error("Ad initialization error:", error);
            }
        }
        // Add event listener to ensure ad links open in a new tab
        const handleAdClick = (event) => {
            const target = event.target;
            if (target.tagName === "A" && !target.hasAttribute("target")) {
                target.setAttribute("target", "_blank");
            }
        };

        const adContainer = adRef.current;
        if (adContainer) {
            adContainer.addEventListener("click", handleAdClick);
        }

        // Cleanup
        return () => {
            if (adContainer) {
                adContainer.removeEventListener("click", handleAdClick);
            }
        };
    }, []);


    return (
        <div className="row adsRow">
            <div className="col-md-6 ps-0">
                <div className="advertisementview mb-3" style={{ height: '200px' }}>
                    <div
                        className="advertisementContainer"
                        style={{
                            width: "97%",
                            height: "200px",
                            maxHeight: '200px',
                            overflow: "hidden",
                            margin: "20px auto",
                        }}
                    >
                        <ins
                            className="adsbygoogle"
                            style={{
                                display: "block",
                                width: "97%",
                                height: "200px",
                                maxHeight: '200px',
                            }}
                            data-ad-layout-key="-6t+ed+2i-1n-4w"
                            data-ad-client="ca-pub-8691062301030113"
                            // data-ad-slot="9667021934"
                            data-ad-slot="7349331462"
                            // data-ad-format="auto"
                            data-full-width-responsive="true"
                            ref={adRef}
                        ></ins>
                    </div>
                </div>
            </div>
            <div className="col-md-6 pe-0">
                <div className="advertisementview mb-3" style={{ height: '200px' }}>
                    <div
                        className="advertisementContainer"
                        style={{
                            width: "100%",
                            height: "200px",
                            maxHeight: '200px',
                            overflow: "hidden",
                            margin: "20px auto",
                        }}
                    >
                        <ins
                            className="adsbygoogle"
                            style={{
                                display: "block",
                                width: "100%",
                                height: "200px",
                                maxHeight: '200px',
                            }}
                            data-ad-layout-key="-6t+ed+2i-1n-4w"
                            data-ad-client="ca-pub-8691062301030113"
                            // data-ad-slot="9667021934"
                            data-ad-slot="5695666532"
                            // data-ad-format="auto"
                            data-full-width-responsive="true"
                            ref={adRef}
                        ></ins>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PeopleFeedAds;
